import React from 'react';
import './HomePage.css';
import picture8 from './Picture_8.jpeg';
import picture9 from './Picture_9.jpeg';
import mahtabPicture from './Mahtab.jpg';

function HomePage() {
  return (
    <div className="home">
      <div className="hero-section">
        <div className="hero-content">
          <h1>Welcome to Mahtab Care</h1>
          <div className="licensed-banner">
            <span className="banner-icon">✅</span>
            <span className="banner-text">Licensed Home Daycare</span>
            <span className="banner-subtext">CWELCC Program</span>
          </div>
          <p className="hero-subtitle">Nurturing, loving care in a safe home environment</p>
        </div>
      </div>

      <div className="about">
        <div className="about-content">
          <div className="about-text">
            <h2>About Me</h2>
            <div className="about-profile">
              <div className="profile-image">
                <img src={mahtabPicture} alt="Mahtab Shirdelan" />
              </div>
              <div className="profile-text">
                <p>My name is Mahtab Shirdelan. I am 45 years old and a mother of two wonderful children, a 8-year-old daughter and a 20-year-old son. I hold a bachelor's degree in Chemistry and I am fluent in English and Farsi.</p>
                <p>I have a deep love for children and am known for my kindness, patience, and nurturing approach. My passion for child development drives me to create a warm, educational, and stimulating environment where every child can thrive.</p>
              </div>
            </div>
          </div>
          <div className="about-highlights">
            <div className="highlight-item">
              <span className="highlight-icon">🎓</span>
              <span>Bachelor's in Chemistry</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">🌍</span>
              <span>English & Farsi Fluent</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">❤️</span>
              <span>Mother of Two</span>
            </div>
          </div>
        </div>
      </div>

      <div className="house">
        <div className="house-content">
          <div className="house-text">
            <h2>About Our Home</h2>
            <p>Our licensed home daycare is located in the basement of our house, which has its own separate entrance for privacy and convenience. The space is approximately 700 sqft and is filled with natural light, creating a bright and welcoming atmosphere.</p>
            <p>We've designed the space to be both educational and comfortable, with dedicated areas for learning, play, rest, and meals. Parents are welcome to request a home visit at any time to see our facilities and meet our family.</p>
            <p>Our garage and backyard are also dedicated playground spaces, providing children with additional outdoor play areas and activities.</p>
          </div>
          <div className="house-features">
            <div className="feature-item">
              <span className="feature-icon">🚪</span>
              <span>Separate Entrance</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">☀️</span>
              <span>Natural Light</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📏</span>
              <span>700 sqft Space</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🏠</span>
              <span>Home Environment</span>
            </div>
          </div>
        </div>
      </div>

      <div className="pictures">
        <div className="picture-container">
          <img src={picture8} alt="Our daycare space" />
          <p className="picture-caption">Our welcoming daycare environment</p>
        </div>
        <div className="picture-container">
          <img src={picture9} alt="Learning and play area" />
          <p className="picture-caption">Learning and play area</p>
        </div>
      </div>

      <div className="video-section">
        <h2>Take a Virtual Tour</h2>
        <p className="video-description">See our facilities and get a feel for our nurturing environment</p>
        <div className="video-container">
          <video 
            controls 
            muted 
            loop
            poster={picture8}
            className="daycare-video"
          >
            <source src={require('./daycare.mp4')} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
}

export default HomePage;